import { turboproApiLista } from '@/api/turbopro';
import type { ListarParametrosResponse, ParametroRelatorioApi } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function listarParametrosApi(relatorioId: number): Promise<ListarParametrosResponse> {
  const resposta = await turboproApiLista<ParametroRelatorioApi>(
    `Relatorios/ListarParametros?relatorio_id=${relatorioId}`,
    { headers: getRelatoriosHeaders() }
  );
  return resposta.data ?? [];
}
